import { render, staticRenderFns } from "./sectionTitle.vue?vue&type=template&id=49bb692d&scoped=true"
import script from "./sectionTitle.vue?vue&type=script&lang=js"
export * from "./sectionTitle.vue?vue&type=script&lang=js"
import style0 from "./sectionTitle.vue?vue&type=style&index=0&id=49bb692d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb692d",
  null
  
)

export default component.exports